import { SeccionBlog } from "./seccion-blog";

export class SeccionBlogTexto extends SeccionBlog {
    public texto: string;
}
